import { ENTER } from '@angular/cdk/keycodes'
import { CommonModule } from '@angular/common'
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms'
import { MatDialog, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { TranslateModule } from '@ngx-translate/core'

import { parseQRCodeTagId } from '@/shared/tools/tag.tools'
import { Subscription } from 'rxjs'
import { ScanTagDialogComponent } from './scan-tag-dialog/scan-tag-dialog.component'

@Component({
  selector: 'app-scan-tag-input',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, TranslateModule],
  templateUrl: './scan-tag-input.component.html',
  styleUrls: ['./scan-tag-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ScanTagInputComponent),
    },
  ],
})
export class ScanTagInputComponent
  implements OnInit, OnDestroy, AfterViewInit, ControlValueAccessor
{
  @ViewChild('input') input!: ElementRef<HTMLInputElement>

  @Input()
  name!: string

  @Input()
  type: string = 'text'

  @Input()
  inputmode!: string

  @Input()
  pattern!: string

  placeholder: string = ''

  @Input()
  scanParseFn: Function = parseQRCodeTagId

  @Input()
  public set disabled(value: boolean) {
    this._disabled = value
  }

  public get disabled(): boolean {
    return this._disabled
  }

  @Output()
  onChangeCamera = new EventEmitter<string>()

  @Output()
  onChangePaste = new EventEmitter<string>()

  @Output()
  blur = new EventEmitter<Event>()

  @Output()
  focus = new EventEmitter<Event>()

  @Output()
  change = new EventEmitter<string>()

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    event.preventDefault()
    if ([ENTER].includes(event.keyCode)) {
      // if (this._isFocus) {
      this.blurInput()
      //}
    }
  }

  public touched: boolean = false
  public enableCamera: boolean = true
  public loading: boolean = false

  public value: string = ''

  onChange: any = () => {}
  onTouched: any = () => {}

  private _isFocus: boolean = false
  private _preventBlur: boolean = false
  private _disabled: boolean = false
  private _dialogRef: MatDialogRef<ScanTagDialogComponent> | null = null
  private _globalSettingsSubs$!: Subscription
  private _formSubs$!: Subscription

  constructor(private _dialog: MatDialog) {}

  writeValue(value: number): void {
    this.value = this.scanParseFn(value)
    this.change.emit(this.value)
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  ngOnInit() {}

  ngAfterViewInit() {
    // console.log('AFTER VIEW CHANGE')
    this.focusInput()
  }
  public blurInput(): void {
    if (this.input?.nativeElement) {
      this.input.nativeElement.blur()
    }
  }
  public focusInput() {
    // console.log('FOCUS NATIVE INPUT')
    if (this.input?.nativeElement) {
      this.input.nativeElement.focus()
    }
  }

  public onBlur(e: Event) {
    this.blur.emit(e)
  }  

  public onClear() {
    // this.formControl.reset()
    if (this._disabled) return
    this.value = ''
    this.onChange('')
    setTimeout(() => this.focusInput(), 0)
  }
  // public onBlur(e) {
  //   this.blur.emit(e)
  // }
  public onFocus(e: Event) {
    this.focus.emit(e)
  }
  public onPaste(e: ClipboardEvent) {}
  openCameraDialog(event: Event): void {
    if (this._disabled) {
      return
    }
    this._preventBlur = true
    this._dialogRef = this._dialog.open(ScanTagDialogComponent, {
      width: '100%',
      data: { scanParseFn: this.scanParseFn },
    })
    this._dialogRef.afterClosed().subscribe(
      (taguid) => {
        this._preventBlur = false
        // Si une resultat retournée
        // On checke
        if (this._disabled) {
          return
        }
        this.focusInput()
        if (taguid) {
          this.value = this.scanParseFn(taguid)
          this.onChange(this.value)
          this.onChangeCamera.emit(this.value)
          this.change.emit(this.value)
        }
        this._dialogRef = null
      },
      () => (this._preventBlur = false),
      () => (this._preventBlur = false)
    )
  }

  keyDown(event: KeyboardEvent){
    if(event.code == "Tab" || event.code == "Enter"){
      //this.add(event);
    }
  }

  cleanEventValue(eventValue: string){
    if(eventValue.indexOf(';') !== -1){
        var splitted = eventValue.split(';');
        if(splitted.length >=2){
          eventValue = splitted[0].replace(/^0+/, '');
        }
    }
    return eventValue;
  }

  inputChange(e: Event) {
    const input = e.target as HTMLInputElement
    var cleanValue = this.cleanEventValue(input.value);
    this.value = this.scanParseFn(cleanValue);
    this.onChange(this.value)
    this.change.emit(this.value)
  }

  ngOnDestroy() {
    if (!!this._globalSettingsSubs$) this._globalSettingsSubs$.unsubscribe()
    if (!!this._formSubs$) this._formSubs$.unsubscribe()
  }
}
